import { select, put } from 'redux-saga/effects';

import * as actions from '../../actions';

import addGroupRandomiseChildGroup from './addGroupRandomiseChildGroup';

export default function*(action) {
  const surveysState = yield select(state => state.surveys);
  const authState = yield select(state => state.auth);

  let newState = { ...surveysState };

  newState = addGroupRandomiseChildGroup(newState, action.parentGroupId);
  yield put({ type: actions.SET_NEW_STATE, newState: newState.newState });

  // Update survey
  const surveyUpdateContent = {
    survey: newState.newState.survey.id,
    content: newState.newState.survey.content
  };
  action.api(
    'updateSurvey',
    { variables: surveyUpdateContent },
    undefined,
    undefined,
    authState
  );
}
